import React, {Component} from "react";
import constants from "../../constants";
import axios from "axios";
import BarTitle from "../../components/BarTitle";
import Painel from "../../components/Painel";
import {toast} from "react-toastify";
import * as XLSX from 'xlsx';
import * as fs from 'fs';
import './style.css';


class WalletReports extends Component
{
    baseUrl = '';
    isSuperUser = '';
    token = '';
    userId = '';

    dateInit = '';
    dateEnd = '';
    status = '';
    merchant = '';

    constructor(props) {
        super(props);
        this.state = {
            historicTransactions: [],
            merchants: [],
            merchantQuery: '',
            merchantSelect : {},
            paramsSearch: {},
            loadingSearch: false,
            loadingExport: false,
        }

        this.isSuperUser = localStorage.getItem('is_super_user');
        this.token = localStorage.getItem('token');
        this.userId = localStorage.getItem('id_establishment');

        this.baseUrl = constants().URL_API;

        this.getMerchants = this.getMerchants.bind(this);
        this.selectMerchant = this.selectMerchant.bind(this);
        this.changeDateInit = this.changeDateInit.bind(this);
        this.changeDateEnd = this.changeDateEnd.bind(this);
        this.changeStatus= this.changeStatus.bind(this);
        this.searchReports= this.searchReports.bind(this);
        this.exportToExcel= this.exportToExcel.bind(this);
        this.InputMerchants= this.InputMerchants.bind(this);
    }

    //FUNCTIONS FORMATE
    currencyFormat(num)
    {
        num = Number(num);
        return 'R$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    formatDate(date)
    {
        const _date = new Date(date);
        return _date.toLocaleDateString() + ' ' + _date.toLocaleTimeString();
    }

    async getMerchants(el)
    {
        const query = el.target.value;
        axios.get(this.baseUrl+'/merchants/query/'+query)
            .then(response => {
                const data = response.data;
                if (data.code === 1)
                {
                    this.setState({merchants: data.details ? data.details : []})
                }
            })
    }

    async selectMerchant(el)
    {

        const merchantSelect = this.state.merchants.filter((v) => {
             if (v.name === el.target.value)
                 return v;
        })[0]

        this.merchant = merchantSelect;
    }

    async changeDateInit(el)
    {
        this.dateInit = el.target.value;
    }

    async changeDateEnd(el)
    {
        this.dateEnd = el.target.value;
    }

    async changeStatus(el)
    {
        this.status = el.target.value;
    }

    searchReports()
    {
        const params = {
            userId: this.userId,
            dateInit: this.dateInit,
            dateEnd: this.dateEnd,
            status: this.status,
            merchantId: this.merchant.id ?  this.merchant.id : false
        };

        this.setState({loadingSearch: true})
        axios.post(this.baseUrl+'/wallets/reports', params)
            .then(response => {
                const data = response.data
                this.setState({loadingSearch: false})
                if (data.code === 1)
                {
                    this.setState({'historicTransactions': data.details ? data.details : []})
                }
                else if(data.code === 2)
                {
                    this.setState({'historicTransactions': []})
                    toast.info(data.message);
                }
                else if(data.code === 3)
                {
                    this.setState({'historicTransactions': []})
                    toast.error(data.message);
                }
            }).catch((error) => {
                this.setState({loadingSearch: false})
                console.error(error);
            })
    }

    convertValue(_value)
    {
    let value = Number(_value).toFixed(2);
    return parseFloat(value);
    //return parseFloat(_value).toFixed(2).replaceAll('.', ',');
    }

    convertDateTime(_value)
    {
        let valueSplit = _value.split(' ');
        let date = valueSplit[0];
        let hour = valueSplit[1];

        return date.split('-').reverse().join('/') + '-' + hour;
    }

    convertDateToExcel(_value)
    {
        let valueSplit = _value.split(' ');
        let date = valueSplit[0];

        return date.split('-').reverse().join('-');
    }

    async exportToExcel()
    {
        this.setState({loadingSearch: true})
        let data = [];
        let total = 0;
        let totalTax = 0;
        let totalCredits = 0;
        for(let item of this.state.historicTransactions)
        {
            let dataToPush = {
                'ID': item.wallet_id,
                'Unique Id': item.unique_id,
                'Estabelecimento' :  item.merchantName,
                'Descrição': item.description,
                'Status': item.status,
                'Forma de pagamento': item.payment_method,
                'Data Recarga': this.convertDateTime(item.date_created),
                'Valor': this.convertValue(item.amount),
                'Taxa de Recarga': this.convertValue(item.tax_amount),
                'Recarga': this.convertValue(Number(item.amount) - Number(item.tax_amount))
            };
            data.push(dataToPush);
            total+= Number(item.amount);
            totalTax+= Number(item.tax_amount);
            totalCredits+= Number(Number(item.amount) - Number(item.tax_amount))
        }
        let dataToPush = {
            'ID': '',
            'Unique Id': '',
            'Estabelecimento' : '',
            'Descrição': '',
            'Status': '',
            'Forma de pagamento': '',
            'Data Recarga': 'Total',
            'Valor': this.convertValue(total),
            'Taxa de Recarga': this.convertValue(totalTax),
            'Recarga': this.convertValue(totalCredits),
        };

        data.push(dataToPush)
        let workSheet = XLSX.utils.json_to_sheet(data);
        let workBook = XLSX.utils.book_new();
        let name = "Relatório";
        if (this.dateInit)
        {
            name += ' ' + this.convertDateToExcel(this.dateInit);
        }
        if(this.dateEnd)
        {
            if(this.dateInit !== this.dateEnd)
            {
                name += '_' + this.convertDateToExcel(this.dateEnd);
            }
        }

        XLSX.utils.book_append_sheet(workBook, workSheet, name);
        XLSX.writeFile(workBook, name+".xlsx", { compression: true })
        this.setState({loadingSearch: false})
    }


    InputMerchants()
    {
        return (
            <div className="col-lg-3">
                <label>Estabelecimentos</label>
                <input type="text" className="form-control" list="merchants_list"
                       onInput={this.selectMerchant} onKeyUp={this.getMerchants}/>

                <datalist id="merchants_list">
                    {
                        this.state.merchants ? this.state.merchants.map(item => {
                            return (
                                <option value={item.name} id={item.id}>{item.name}</option>
                            )
                        }) : ''
                    }
                </datalist>
            </div>
        );
    }

    render() {
        return (
            <div>
                <BarTitle name="Relatórios Carteira"/>
                <div className='wrapper-md'>

                    <Painel title="Filtros">
                        <div className="div-flex">
                            <div className="col-lg-2">
                                <label>Data Inicial</label>
                                <input type="date" className="form-control" onChange={this.changeDateInit}/>
                            </div>

                            <div className="col-lg-2">
                                <label>Data Final</label>
                                <input type="date" className="form-control" onChange={this.changeDateEnd}/>
                            </div>

                            {this.isSuperUser === 'true' ? this.InputMerchants() : ''}

                            <div className="col-lg-2">
                                <div>Status</div>
                                <div className='form-group-checkbox'>
                                    <input type="radio" name="status" className="" id="pago" value='Pago' onChange={this.changeStatus}/>
                                    <label htmlFor="pago">Pago</label>
                                </div>
                                <div className='form-group-checkbox'>
                                    <input type="radio" name="status" className="" id="Pendente" value='Pendente' onChange={this.changeStatus}/>
                                    <label htmlFor="Pendente">Pendente</label>
                                </div>

                                <div className='form-group-checkbox'>
                                    <input type="radio" name="status" className="" id="cancelado" value='Cancelado' onChange={this.changeStatus}/>
                                    <label htmlFor="cancelado">Cancelado</label>
                                </div>
                            </div>

                            <div className="col-lg-3">
                                <button className="btn btn-block btn-primary btn-loading" onClick={this.searchReports}>
                                    {this.state.loadingSearch ? (<div className="lds-dual-ring"></div>): ''}
                                    Buscar
                                </button>
                                <button className="btn btn-block btn-dark btn-loading" onClick={this.exportToExcel}>
                                    {this.state.loadingExport ? (<div className="lds-dual-ring"></div>): ''}
                                    Exportar
                                </button>
                            </div>
                        </div>

                    </Painel>

                    <Painel title="Transações">
                        <div className="">
                            <table className='table table-striped' id='table-transaction'>
                                <thead>
                                <tr>
                                    <td>ID</td>
                                    <td>Unique ID</td>
                                    {this.isSuperUser === 'true' ? (<td>Estabelecimento</td>) : ''}
                                    {this.isSuperUser === 'true' ? (<td>Taxa de Recarga</td>) : ''}
                                    <td>Descrição</td>
                                    <td>Status</td>
                                    <td>Forma de Pagamento</td>
                                    <td>Data Criação</td>
                                    <td>Valor</td>
                                    {/*<td>Fatura</td>*/}
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.historicTransactions.length > 0 ? this.state.historicTransactions.map((data, i) => (
                                            <tr key={i}>
                                                <td>{data.wallet_transaction_id}</td>
                                                <td>{data.unique_id}</td>
                                                {this.isSuperUser === 'true' ? (<td>{data.merchantName}</td>) : ''}
                                                {this.isSuperUser === 'true' ? (<td>{this.currencyFormat(data.tax_amount)}</td>) : ''}
                                                <td>{data.description}</td>
                                                <td>{data.status}</td>
                                                <td>{data.payment_method ? data.payment_method.toUpperCase() : ''}</td>
                                                <td>{this.formatDate(data.date_created)}</td>
                                                <td>{this.currencyFormat(data.amount)}</td>
                                                {/*<td>
                                            {
                                                (data.payment_method && data.payment_method.toLowerCase() === 'boleto')
                                                ?
                                                <button onClick={() => {
                                                    this.openModalTransactionDetails(data.unique_id)
                                                }} className="btn btn-default">
                                                    Ver Fatura
                                                </button>
                                                :
                                                " "
                                            }
                                        </td>*/}
                                            </tr>
                                        ))
                                        :
                                        (<tr>
                                            <td colSpan={8}>Não existe registros</td>
                                        </tr>)
                                }
                                </tbody>
                            </table>


                        </div>
                    </Painel>
                </div>
            </div>
    );
    }

    }


    export default WalletReports;


// WEBPACK FOOTER //
// ./src/views/WalletReports/index.js